module.exports = __webpack_public_path__ + "img/towncrier.18a4377b.png";